<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="120"
    >
    <FormItem label="文案" prop="text">
        <Input v-model="formValidate.text" type="textarea"  placeholder="请填写文案"></Input>
      </FormItem>

      <FormItem label="视频标题" prop="video_title">
        <Input v-model="formValidate.video_title" placeholder="请填写视频标题"></Input>
      </FormItem>

      <FormItem label="视频简介" prop="video_desc">
        <Input v-model="formValidate.video_desc" type="textarea" placeholder="请填写视频简介"></Input>
      </FormItem>
      
    <FormItem label="请上传字幕文件" prop="srt_path">
        <input type="file" accept=".srt"  @change="handleSrtFileChange" ref="videoFileInput" />
        <label class="search-label">{{show_srt_path}}</label>
    </FormItem>

      <template v-for="(item, index) in formValidate.goodItems">
          <FormItem
                  :label="'金句评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                      <Button @click="handleGoodCommentRemove(index)">删除</Button>
                  </Col>
              </Row>
          </FormItem>
        </template>

      <FormItem>
          <Row>
              <Col span="12">
                  <Button type="dashed" long @click="handleGoodAdd" icon="md-add">添加</Button>
              </Col>
          </Row>
      </FormItem>

        <template v-for="(item, index) in formValidate.blackItems">
          <FormItem
                  :label="'黑粉评论' + (index + 1)">
              <Row>
                  <Col span="18">
                      <Input type="text" v-model="item.value" placeholder="请填写"></Input>
                  </Col>
                  <Col span="4" offset="1">
                      <Button @click="handleBlackCommentRemove(index)">删除</Button>
                  </Col>
              </Row>
          </FormItem>
        </template>

        <FormItem>
            <Row>
                <Col span="12">
                    <Button type="dashed" long @click="handleBlackAdd" icon="md-add">添加</Button>
                </Col>
            </Row>
        </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import moment from 'moment';
import { getOssClient } from '@/api/ossClient';

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      userIds:[],
      workTypeIds:[],
      shortVideoClassifyIds:[],
      show_srt_path:'',
      formValidate: {
        id: '',
        text:'',
        video_title:'',
        video_desc:'',
        srt_path:'',
        blackItems:[],
        goodItems:[]
      },
      ruleValidate: {
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData(params){
        this.formValidate.id = params.id.toString()
        this.formValidate.text = params.text
        this.formValidate.video_title = params.video_title
        this.formValidate.video_desc = params.video_desc
        this.formValidate.srt_path = params.srt_path
        this.formValidate.goodItems = JSON.parse(params.good_comment)
        this.formValidate.blackItems = JSON.parse(params.black_comment)

        
        if (params.srt_path != null){
          var srt_path_array = params.srt_path.split("/")
          this.show_srt_path = srt_path_array[srt_path_array.length - 1]
        }
    },
    handleGoodAdd(){
      this.formValidate.goodItems.push({"value":''})
    },
    handleBlackAdd(){
      this.formValidate.blackItems.push({"value":''})
    },
    handleGoodCommentRemove(index){
      this.formValidate.goodItems.splice(index, 1)

    },
    handleBlackCommentRemove(index){
      this.formValidate.blackItems.splice(index, 1)
   },
    async handleSrtFileChange(e){
      const file = e.target.files[0];
      if (!file) return;

      try {
        let currentDate = moment().format('YYYY-MM-DD');
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        const client = await getOssClient();
        const result = await client.put('short_video/' + currentDate + "/check_srt_task/" + name, file);
        if (result['res']['statusCode'] == 200){
          this.formValidate.srt_path = result['url']
          this.$Message.info('上传成功');
        }else{
          this.$Message.error('上传失败');
        }
      } catch (error) {
        this.$Message.error('上传失败');
      }
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
